import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MoodengCreditSection from '../../request/MoodengCreditSection';
import './About.css'

export default function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <>
      <div id='guide' className="flex overflow-hidden flex-col bg-zinc-900">
        <div className="flex flex-col items-center w-full min-h-full max-md:max-w-full">
          <div className="flex flex-col h-[1086px] items-start w-[1425px] relative">
            <div className="h-[438px] bg-[#f7c9ff] rounded-[60px] overflow-hidden w-[1425px] relative">
              <div className="relative w-[1274px] h-[361px] top-[17px] left-[53px]">
                <div className="absolute w-[1272px] h-[361px] top-0 left-0">
                  <div className="absolute w-[1221px] h-[318px] top-[43px] left-[49px]">
                    <div className="relative w-[961px] h-[301px] top-[17px] left-14">
                      <div className="absolute w-[425px] h-[83px] top-[51px] left-[513px] bg-[#33d6a8] rounded-2xl z-2" />

                      <div className="absolute w-[961px] h-[301px] top-0 left-0">
                        <div className="absolute w-[502px] h-[301px] top-0 left-0">
                          <img
                            className="absolute w-[168px] h-[218px] top-[83px] left-[334px] object-cover"
                            alt="Screenshot"
                            src="https://c.animaapp.com/wawSHnKX/img/screenshot-2024-09-19-at-15-51-16-removebg-preview-1.png"
                          />

                          <img
                            className="absolute w-[323px] h-[165px] top-0 left-0"
                            alt="Vector"
                            src="https://c.animaapp.com/wawSHnKX/img/vector.svg"
                          />
                        </div>

                        <p className="absolute w-[392px] top-[60px] left-[537px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-xl tracking-[0] leading-8 z-3">
                          To get funded, you need to write why you need it, so
                          someone will fund you.
                        </p>

                        <img
                          className="w-[146px] h-[136px] top-[165px] left-48 absolute object-cover"
                          alt="File"
                          src="https://c.animaapp.com/wawSHnKX/img/file--4--1-1.png"
                        />
                      </div>

                      <div className="absolute w-[376px] h-[83px] top-[193px] left-[519px] bg-[#ffe635] rounded-2xl" />
                    </div>
                  </div>

                  <div className="absolute w-[660px] h-8 top-0 left-0 [font-family:'Telex',Helvetica] font-normal text-[#171420] text-3xl tracking-[0] leading-8 whitespace-nowrap">
                    Welcome to Moodeng Academy
                  </div>
                </div>

                <div className="absolute w-[1120px] h-[285px] top-[77px] left-[155px]">
                  <div className="absolute w-[289px] h-32 top-0 left-0">
                    <img
                      className="absolute w-[52px] h-11 top-[55px] left-[237px]"
                      alt="Group"
                      src="https://c.animaapp.com/wawSHnKX/img/group-26086621@2x.png"
                    />

                    <p className="absolute w-[249px] h-32 top-0 left-0 [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-xl tracking-[0] leading-8">
                      <span className="[font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-xl tracking-[0] leading-8">
                        Hi there! I am Mecha! Leader of the Mechas, here to help{" "}
                      </span>

                      <span className="[font-family:'PP_Telegraf-Regular',Helvetica] font-bold text-white text-xl tracking-[0] leading-8">
                        Moodeng
                      </span>

                      <span className="[font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-xl tracking-[0] leading-8">
                        {" "}
                        explain how her platform works!{" "}
                      </span>
                    </p>
                  </div>

                  <p className="absolute w-[328px] top-[184px] left-[487px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-black text-xl tracking-[0] leading-8">
                    And make sure to submit a request within your credit limit.
                  </p>

                  <img
                    className="absolute w-[23px] h-[25px] top-[84px] left-[455px]"
                    alt="Bubble point"
                    src="https://c.animaapp.com/wawSHnKX/img/bubble-point.svg"
                  />

                  <img
                    className="absolute w-5 h-6 top-[188px] left-[458px]"
                    alt="Bubble point"
                    src="https://c.animaapp.com/wawSHnKX/img/bubble-point-1.svg"
                  />

                  <div className="absolute w-[188px] h-[285px] top-0 left-[928px]">
                    <div className="relative w-[190px] h-[285px]">
                      <div className="absolute w-[190px] h-[285px] top-0 left-0">
                        <div className="relative w-[188px] h-[285px]">
                          <div className="absolute w-[188px] h-[285px] top-0 left-0 bg-[#ffffff1a] shadow-[0px_2px_2px_#00000040]">
                            <div className="relative w-[168px] h-[272px] top-[7px] left-2.5 bg-white rounded-md overflow-hidden">
                              <div className="absolute w-[158px] h-[29px] top-[5px] left-[5px] bg-[#f1f1f1] rounded-md overflow-hidden border-[0.5px] border-solid border-[#dddddd]">
                                <button className="all-[unset] box-border flex w-[78px] h-[23px] gap-2.5 px-2.5 py-[9px] absolute top-[3px] left-[3px] bg-[#040033] rounded items-center justify-center overflow-hidden">
                                  <div className="relative w-fit mt-[-1.00px] mb-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-[7px] text-center tracking-[0] leading-[7px] whitespace-nowrap">
                                    Ask For Help
                                  </div>
                                </button>

                                <div className="absolute top-2.5 left-[98px] text-[#00000099] text-[7px] leading-[7px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Offer Help
                                </div>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[74px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  How much do you need today? i.e. $15
                                </p>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[164px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  Enter how much you will payback? i.e. $17
                                </p>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[196px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  Type your reason? i.e. an emergency, etc.
                                </p>
                              </div>

                              <div className="inline-flex items-center gap-[3px] absolute top-[103px] left-[5px]">
                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#585858] text-[7px] tracking-[0] leading-3 whitespace-nowrap">
                                    $10
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $15
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $20
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $40
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#585858] text-[7px] tracking-[0] leading-3 whitespace-nowrap">
                                    Other
                                  </div>
                                </div>
                              </div>

                              <div className="flex w-[158px] items-center justify-between px-[7.5px] py-1 absolute top-[132px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <div className="inline-flex flex-col items-start justify-center gap-[3px] relative flex-[0_0_auto]">
                                  <div className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] text-[#00000099] text-[6px] leading-[6px] font-normal tracking-[0] whitespace-nowrap">
                                    Repayment timeline
                                  </div>

                                  <div className="relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-black text-[7px] tracking-[0] leading-[7px] whitespace-nowrap">
                                    dd/mm/yy
                                  </div>
                                </div>

                                <svg
                                  className="!relative !w-3 !h-3"
                                  fill="none"
                                  height="13"
                                  viewBox="0 0 13 13"
                                  width="13"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.04639 5.20223H10.9584"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.72098 7.15486H8.72562"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M6.50223 7.15486H6.50687"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.27884 7.15486H4.28348"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.72098 9.09822H8.72562"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M6.50223 9.09822H6.50687"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.27884 9.09822H4.28348"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.52188 1.5V3.14539"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.48282 1.5V3.14539"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    clipRule="evenodd"
                                    d="M8.61913 2.28955H4.38548C2.91714 2.28955 2 3.10752 2 4.61106V9.13589C2 10.6631 2.91714 11.5 4.38548 11.5H8.6145C10.0875 11.5 11 10.6773 11 9.17371V4.61106C11.0046 3.10752 10.0921 2.28955 8.61913 2.28955Z"
                                    fillRule="evenodd"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />
                                </svg>
                              </div>

                              <button className="all-[unset] box-border flex w-[158px] gap-2.5 px-2.5 py-2 absolute top-[234px] left-[5px] bg-[#2154e8] rounded items-center justify-center overflow-hidden">
                                <div className="relative w-fit text-white text-[8px] leading-[8px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Submit Request
                                </div>
                              </button>

                              <div className="flex w-[100px] h-2.5 items-center gap-0.5 px-1 py-px absolute top-10 left-3 bg-[#e2f7f5] rounded">
                                <div className="relative w-2 h-2">
                                  <img
                                    className="absolute w-[7px] h-[5px] top-px left-px"
                                    alt="Style"
                                    src="https://c.animaapp.com/wawSHnKX/img/style-1.svg"
                                  />
                                </div>

                                <p className="relative w-fit mt-[-3.00px] mb-[-3.00px] [font-family:'Geist',Helvetica] font-medium text-black text-[5.8px] tracking-[0] leading-[15px] whitespace-nowrap">
                                  Your available credit limit: $15
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="absolute top-16 left-6 [font-family:'Geist',Helvetica] font-medium text-black text-[10px] tracking-[0] leading-[15px] whitespace-nowrap">
                            Set Your Own Terms
                          </div>
                        </div>
                      </div>

                      <div className="absolute w-[190px] h-[285px] top-0 left-0">
                        <div className="relative w-[188px] h-[285px]">
                          <div className="absolute w-[188px] h-[285px] top-0 left-0 bg-[#ffffff1a] shadow-[0px_2px_2px_#00000040]">
                            <div className="relative w-[168px] h-[272px] top-[7px] left-2.5 bg-white rounded-md overflow-hidden">
                              <div className="absolute w-[158px] h-[29px] top-[5px] left-[5px] bg-[#f1f1f1] rounded-md overflow-hidden border-[0.5px] border-solid border-[#dddddd]">
                                <button className="all-[unset] box-border flex w-[78px] h-[23px] gap-2.5 px-2.5 py-[9px] absolute top-[3px] left-[3px] bg-[#040033] rounded items-center justify-center overflow-hidden">
                                  <div className="relative w-fit mt-[-1.00px] mb-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-white text-[7px] text-center tracking-[0] leading-[7px] whitespace-nowrap">
                                    Ask For Help
                                  </div>
                                </button>

                                <div className="absolute top-2.5 left-[98px] text-[#00000099] text-[7px] leading-[7px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Offer Help
                                </div>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[74px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <div className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  Enter amount, i.e. $15
                                </div>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[164px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  Enter amount to repay, i.e. $18
                                </p>
                              </div>

                              <div className="flex w-[158px] items-center gap-2.5 px-2.5 py-[7.5px] absolute top-[196px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-[7px] tracking-[0] leading-[9px] whitespace-nowrap">
                                  Enter reason i.e. an emergency, etc.
                                </p>
                              </div>

                              <div className="inline-flex items-center gap-[3px] absolute top-[103px] left-[5px]">
                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $10
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $15
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $20
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[#585858] text-[7px] leading-3 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $40
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-[5px] px-1.5 py-[5px] relative flex-[0_0_auto] bg-[#f1f1f1] rounded border-[0.5px] border-solid border-[#ffffff33]">
                                  <div className="mt-[-0.50px] text-[7px] leading-3 relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#585858] tracking-[0] whitespace-nowrap">
                                    Other
                                  </div>
                                </div>
                              </div>

                              <div className="flex w-[158px] items-center justify-between px-[7.5px] py-1 absolute top-[132px] left-[5px] bg-white rounded border-[0.5px] border-solid border-[#dddddd]">
                                <div className="inline-flex flex-col items-start justify-center gap-[3px] relative flex-[0_0_auto]">
                                  <div className="relative w-fit mt-[-0.50px] [font-family:'PP_Telegraf-Regular',Helvetica] text-[#00000099] text-[6px] leading-[6px] font-normal tracking-[0] whitespace-nowrap">
                                    Repayment timeline
                                  </div>

                                  <div className="relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-black text-[7px] tracking-[0] leading-[7px] whitespace-nowrap">
                                    dd/mm/yy
                                  </div>
                                </div>

                                <svg
                                  className="!relative !w-3 !h-3"
                                  fill="none"
                                  height="13"
                                  viewBox="0 0 13 13"
                                  width="13"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.04639 5.20223H10.9584"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.72098 7.15486H8.72562"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M6.50223 7.15486H6.50687"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.27884 7.15486H4.28348"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.72098 9.09822H8.72562"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M6.50223 9.09822H6.50687"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.27884 9.09822H4.28348"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M8.52188 1.5V3.14539"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    d="M4.48282 1.5V3.14539"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />

                                  <path
                                    clipRule="evenodd"
                                    d="M8.61913 2.28955H4.38548C2.91714 2.28955 2 3.10752 2 4.61106V9.13589C2 10.6631 2.91714 11.5 4.38548 11.5H8.6145C10.0875 11.5 11 10.6773 11 9.17371V4.61106C11.0046 3.10752 10.0921 2.28955 8.61913 2.28955Z"
                                    fillRule="evenodd"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="0.75"
                                  />
                                </svg>
                              </div>

                              <button className="all-[unset] box-border flex w-[158px] gap-2.5 px-2.5 py-2 absolute top-[234px] left-[5px] bg-[#2154e8] rounded items-center justify-center overflow-hidden">
                                <div className="relative w-fit text-white text-[8px] leading-[8px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Submit Request
                                </div>
                              </button>

                              <div className="flex w-[100px] h-2.5 items-center gap-0.5 px-1 py-px absolute top-10 left-3 bg-[#e2f7f5] rounded">
                                <div className="relative w-2 h-2">
                                  <img
                                    className="absolute w-[7px] h-[5px] top-px left-px"
                                    alt="Style"
                                    src="https://c.animaapp.com/wawSHnKX/img/style-1.svg"
                                  />
                                </div>

                                <p className="relative w-fit mt-[-3.00px] mb-[-3.00px] [font-family:'Geist',Helvetica] font-medium text-black text-[5.8px] tracking-[0] leading-[15px] whitespace-nowrap">
                                  Your available credit limit: $15
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="absolute top-16 left-6 [font-family:'Geist',Helvetica] font-medium text-black text-[10px] tracking-[0] leading-[15px] whitespace-nowrap">
                            Set Your Own Terms
                          </div>
                        </div>
                      </div>

                      <img
                        className="absolute w-2.5 h-[9px] top-[66px] left-[124px] object-cover"
                        alt="Image"
                        src="https://c.animaapp.com/wawSHnKX/img/image-2.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative w-[1425px] h-[748px] overflow-hidden">
              <div className="relative w-[1084px] h-[571px] top-[92px] left-[154px]">
                <div className="absolute w-[265px] h-[42px] top-0.5 left-[819px]">
                  <div className="h-[42px]">
                    <div className="relative w-[265px] h-[42px] bg-[#f6f6f6] rounded-[100px] overflow-hidden">
                      <div className="absolute w-[223px] h-[22px] top-2.5 left-[34px] [font-family:'Inter',Helvetica] font-normal text-[#171420] text-[21.8px] tracking-[0] leading-[22px]">
                        <Link to="/dashboard#request">See Request Board</Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute w-[974px] h-[571px] top-0 left-0">
                  <div className="absolute w-[532px] h-[278px] top-[194px] left-[442px] bg-white rounded-[10px] shadow-[0px_0px_10px_#ffffff1a]">
                    <div className="relative w-[528px] h-[218px] top-10 left-5">
                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-0 left-0">
                        <div className="relative w-fit mt-[-1.00px] [font-family:'Arial-Bold',Helvetica] font-bold text-[#333333] text-2xl tracking-[0] leading-[normal] whitespace-nowrap">
                          How It Works
                        </div>
                      </div>

                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-12 left-0">
                        <p className="relative w-fit mt-[-1.00px] [font-family:'Arial-Regular',Helvetica] font-bold text-[#333333] text-base tracking-[0] leading-[normal] whitespace-nowrap">
                          1. Enter your loan amount
                        </p>
                      </div>

                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-[82px] left-0">
                        <div className="relative w-fit mt-[-1.00px] [font-family:'Arial-Regular',Helvetica] font-bold text-[#333333] text-base tracking-[0] leading-[normal] whitespace-nowrap">
                          2. Choose repayment timeline
                        </div>
                      </div>

                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-[116px] left-0">
                        <div className="relative w-fit mt-[-1.00px] [font-family:'Arial-Regular',Helvetica] font-bold text-[#333333] text-base tracking-[0] leading-[normal] whitespace-nowrap">
                          3. Specify payback amount
                        </div>
                      </div>

                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-[150px] left-0">
                        <p className="relative w-fit mt-[-1.00px] [font-family:'Arial-Regular',Helvetica] font-bold text-[#333333] text-base tracking-[0] leading-[normal] whitespace-nowrap">
                          4. Explain your reason for the loan
                        </p>
                      </div>

                      <div className="flex flex-col w-[492px] items-start pt-0 pb-px px-0 absolute top-[184px] left-0">
                        <div className="relative w-fit mt-[-1.00px] [font-family:'Arial-Regular',Helvetica] font-bold text-[#333333] text-base tracking-[0] leading-[normal] whitespace-nowrap">
                          5. Submit your request
                        </div>
                      </div>

                      <img
                        className="w-[284px] h-[218px] top-0 left-[244px] absolute object-cover"
                        alt="Screenshot"
                        src="https://c.animaapp.com/wawSHnKX/img/screenshot-2024-09-19-at-15-51-16-removebg-preview-3.png"
                      />
                    </div>
                  </div>

                  <div className="absolute w-[375px] h-[571px] top-0 left-0">
                    <div className="relative w-[377px] h-[571px]">
                      <div className="absolute w-[377px] h-[571px] top-0 left-0">
                        <div className="relative w-[375px] h-[571px]">
                          <div className="absolute w-[375px] h-[571px] top-0 left-0 bg-[#ffffff1a] shadow-[0px_4px_4px_#00000040]">
                            <div className="relative w-[335px] h-[543px] top-3.5 left-5 bg-white rounded-xl overflow-hidden">
                              <div className="absolute w-[315px] h-[58px] top-2.5 left-2.5 bg-[#f1f1f1] rounded-xl overflow-hidden border border-solid border-[#dddddd]">
                                <button className="all-[unset] box-border flex w-[157px] h-[46px] gap-5 px-5 py-[18px] absolute top-1.5 left-1.5 bg-[#040033] rounded-lg items-center justify-center overflow-hidden">
                                  <div className="relative w-fit mt-[-2.00px] mb-[-2.00px] text-white text-sm leading-[14px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                    Ask For Help
                                  </div>
                                </button>

                                <div className="absolute top-[21px] left-[197px] text-[#00000099] text-sm leading-[14px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Offer Help
                                </div>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[148px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  How much do you need today? i.e. $15
                                </p>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[328px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  Enter how much you will payback? i.e. $17
                                </p>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[391px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  Type your reason? i.e. an emergency, etc.
                                </p>
                              </div>

                              <div className="inline-flex items-center gap-1.5 absolute top-[206px] left-2.5">
                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $10
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $15
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $20
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $40
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-sm leading-6 relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#585858] tracking-[0] whitespace-nowrap">
                                    Other
                                  </div>
                                </div>
                              </div>

                              <div className="flex w-[315px] items-center justify-between px-[15px] py-2 absolute top-[265px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <div className="inline-flex flex-col items-start justify-center gap-1.5 relative flex-[0_0_auto]">
                                  <div className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-xs tracking-[0] leading-3 whitespace-nowrap">
                                    Repayment timeline
                                  </div>

                                  <div className="relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-black text-sm tracking-[0] leading-[14px] whitespace-nowrap">
                                    dd/mm/yy
                                  </div>
                                </div>

                                <svg
                                  className="!relative !w-6 !h-6"
                                  fill="none"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.09264 9.40426H20.9166"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.4421 13.3097H16.4513"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M12.0046 13.3097H12.0139"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.55789 13.3097H7.56716"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.4421 17.1962H16.4513"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M12.0046 17.1962H12.0139"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.55789 17.1962H7.56716"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.0437 2V5.29078"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.96551 2V5.29078"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    clipRule="evenodd"
                                    d="M16.2383 3.5792H7.77096C4.83427 3.5792 3 5.21513 3 8.22222V17.2719C3 20.3262 4.83427 22 7.77096 22H16.229C19.175 22 21 20.3546 21 17.3475V8.22222C21.0092 5.21513 19.1842 3.5792 16.2383 3.5792Z"
                                    fillRule="evenodd"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />
                                </svg>
                              </div>

                              <button className="all-[unset] box-border flex w-[315px] gap-5 px-5 py-4 absolute top-[469px] left-2.5 bg-[#2154e8] rounded-lg items-center justify-center overflow-hidden">
                                <div className="relative w-fit text-white text-base leading-4 whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Submit Request
                                </div>
                              </button>

                              <div className="flex w-[200px] h-5 items-center gap-1 px-2 py-0.5 absolute top-20 left-[25px] bg-[#e2f7f5] rounded-lg">
                                <div className="relative w-4 h-4">
                                  <img
                                    className="absolute w-[13px] h-[11px] top-[3px] left-px"
                                    alt="Style"
                                    src="https://c.animaapp.com/wawSHnKX/img/style-3.svg"
                                  />
                                </div>

                                <p className="relative w-fit mt-[-6.00px] mb-[-6.00px] [font-family:'Geist',Helvetica] font-medium text-black text-[11.5px] tracking-[0] leading-[30px] whitespace-nowrap">
                                  Your available credit limit: $15
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="absolute top-[127px] left-12 [font-family:'Geist',Helvetica] font-medium text-black text-xl tracking-[0] leading-[30px] whitespace-nowrap">
                            Set Your Own Terms
                          </div>
                        </div>
                      </div>

                      <div className="absolute w-[377px] h-[571px] top-0 left-0">
                        <div className="relative w-[375px] h-[571px]">
                          <div className="absolute w-[375px] h-[571px] top-0 left-0 bg-[#ffffff1a] shadow-[0px_4px_4px_#00000040]">
                            <div className="relative w-[335px] h-[543px] top-3.5 left-5 bg-white rounded-xl overflow-hidden">
                              <div className="absolute w-[315px] h-[58px] top-2.5 left-2.5 bg-[#f1f1f1] rounded-xl overflow-hidden border border-solid border-[#dddddd]">
                                <button className="all-[unset] box-border flex w-[157px] h-[46px] gap-5 px-5 py-[18px] absolute top-1.5 left-1.5 bg-[#040033] rounded-lg items-center justify-center overflow-hidden">
                                  <div className="relative w-fit mt-[-2.00px] mb-[-2.00px] text-white text-sm leading-[14px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                    Ask For Help
                                  </div>
                                </button>

                                <div className="absolute top-[21px] left-[197px] text-[#00000099] text-sm leading-[14px] whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Offer Help
                                </div>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[148px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <div className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  Enter amount, i.e. $15
                                </div>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[328px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  Enter amount to repay, i.e. $18
                                </p>
                              </div>

                              <div className="flex w-[315px] items-center gap-5 px-5 py-[15px] absolute top-[391px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <p className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-sm tracking-[0] leading-[18px] whitespace-nowrap">
                                  Enter reason i.e. an emergency, etc.
                                </p>
                              </div>

                              <div className="inline-flex items-center gap-1.5 absolute top-[206px] left-2.5">
                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $10
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $15
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $20
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-[#585858] text-sm leading-6 whitespace-nowrap relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal tracking-[0]">
                                    $40
                                  </div>
                                </div>

                                <div className="inline-flex items-center justify-center gap-2.5 px-3 py-2.5 relative flex-[0_0_auto] bg-[#f1f1f1] rounded-lg border border-solid border-[#ffffff33]">
                                  <div className="mt-[-1.00px] text-sm leading-6 relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#585858] tracking-[0] whitespace-nowrap">
                                    Other
                                  </div>
                                </div>
                              </div>

                              <div className="flex w-[315px] items-center justify-between px-[15px] py-2 absolute top-[265px] left-2.5 bg-white rounded-lg border border-solid border-[#dddddd]">
                                <div className="inline-flex flex-col items-start justify-center gap-1.5 relative flex-[0_0_auto]">
                                  <div className="relative w-fit mt-[-1.00px] [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-[#00000099] text-xs tracking-[0] leading-3 whitespace-nowrap">
                                    Repayment timeline
                                  </div>

                                  <div className="relative w-fit [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-black text-sm tracking-[0] leading-[14px] whitespace-nowrap">
                                    dd/mm/yy
                                  </div>
                                </div>

                                <svg
                                  className="!relative !w-6 !h-6"
                                  fill="none"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.09264 9.40426H20.9166"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.4421 13.3097H16.4513"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M12.0046 13.3097H12.0139"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.55789 13.3097H7.56716"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.4421 17.1962H16.4513"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M12.0046 17.1962H12.0139"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.55789 17.1962H7.56716"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M16.0437 2V5.29078"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    d="M7.96551 2V5.29078"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />

                                  <path
                                    clipRule="evenodd"
                                    d="M16.2383 3.5792H7.77096C4.83427 3.5792 3 5.21513 3 8.22222V17.2719C3 20.3262 4.83427 22 7.77096 22H16.229C19.175 22 21 20.3546 21 17.3475V8.22222C21.0092 5.21513 19.1842 3.5792 16.2383 3.5792Z"
                                    fillRule="evenodd"
                                    stroke="#110000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                  />
                                </svg>
                              </div>

                              <button className="all-[unset] box-border flex w-[315px] gap-5 px-5 py-4 absolute top-[469px] left-2.5 bg-[#2154e8] rounded-lg items-center justify-center overflow-hidden">
                                <div className="relative w-fit text-white text-base leading-4 whitespace-nowrap [font-family:'PP_Telegraf-Regular',Helvetica] font-normal text-center tracking-[0]">
                                  Submit Request
                                </div>
                              </button>

                              <div className="flex w-[200px] h-5 items-center gap-1 px-2 py-0.5 absolute top-20 left-[25px] bg-[#e2f7f5] rounded-lg">
                                <div className="relative w-4 h-4">
                                  <img
                                    className="absolute w-[13px] h-[11px] top-[3px] left-px"
                                    alt="Style"
                                    src="https://c.animaapp.com/wawSHnKX/img/style-3.svg"
                                  />
                                </div>

                                <p className="relative w-fit mt-[-6.00px] mb-[-6.00px] [font-family:'Geist',Helvetica] font-medium text-black text-[11.5px] tracking-[0] leading-[30px] whitespace-nowrap">
                                  Your available credit limit: $15
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="absolute top-[127px] left-12 [font-family:'Geist',Helvetica] font-medium text-black text-xl tracking-[0] leading-[30px] whitespace-nowrap">
                            Set Your Own Terms
                          </div>
                        </div>
                      </div>

                      <img
                        className="absolute w-5 h-[18px] top-[131px] left-[247px] object-cover"
                        alt="Image"
                        src="https://c.animaapp.com/wawSHnKX/img/image-2-1.png"
                      />
                    </div>
                  </div>
                </div>

                <div className="absolute w-[136px] h-[109px] top-[182px] left-80">
                  <div className="relative w-[131px] h-[102px] top-[7px] left-[5px]">
                    <img
                      className="absolute w-[18px] h-[17px] top-0 left-0"
                      alt="Vector"
                      src="https://c.animaapp.com/wawSHnKX/img/vector-1.svg"
                    />

                    <div className="absolute w-[120px] h-[94px] top-[7px] left-[11px]">
                      <div className="relative w-[151px] h-0.5 top-[46px] left-[-15px] bg-[#00cc92] rotate-[38.02deg]" />
                    </div>
                  </div>
                </div>

                <div className="absolute w-32 h-[124px] top-[274px] left-[322px] rotate-[-34.76deg]">
                  <div className="relative h-[124px]">
                    <div className="w-[116px] top-[54px] left-[26px] bg-[#6d57ff] rotate-[40.74deg] absolute h-0.5" />

                    <div className="absolute w-[105px] h-[93px] top-0 left-[23px]">
                      <img
                        className="absolute w-4 h-5 top-[3px] left-1 rotate-[34.76deg]"
                        alt="Vector"
                        src="https://c.animaapp.com/wawSHnKX/img/vector-2.svg"
                      />

                      <div className="w-[116px] top-[54px] left-[3px] bg-[#6d57ff] rotate-[40.74deg] absolute h-0.5" />
                    </div>

                    <div className="absolute w-[110px] h-[82px] top-[42px] left-0">
                      <img
                        className="absolute w-[15px] h-5 top-[3px] left-1 rotate-[34.76deg]"
                        alt="Vector"
                        src="https://c.animaapp.com/wawSHnKX/img/vector-3.svg"
                      />

                      <div className="w-[116px] top-12 left-[5px] bg-[#ffdd00] rotate-[35.17deg] absolute h-0.5" />
                    </div>
                  </div>
                </div>

                <div className="absolute w-[157px] h-[61px] top-[396px] left-[302px]">
                  <img
                    className="absolute w-[33px] h-[33px] top-7 left-0"
                    alt="Group"
                    src="https://c.animaapp.com/wawSHnKX/img/group-26086640@2x.png"
                  />

                  <div className="w-[141px] top-[21px] left-[19px] bg-[#48abdd] rotate-[-17.25deg] absolute h-0.5" />
                </div>
              </div>
            </div>
          </div>
          <div id='system' className="flex overflow-hidden flex-col px-24 py-16 mt-20 max-w-full bg-blend-normal bg-neutral-100 rounded-[60px] w-[1425px] max-md:px-5 max-md:mt-10">
            <div className="flex overflow-hidden flex-wrap gap-2.5 items-start w-full text-4xl leading-none bg-blend-normal min-h-[37px] text-zinc-900">
              <div className="overflow-hidden grow shrink bg-blend-normal min-w-[240px] w-[1151px] max-md:max-w-full">
                CREDIT GROWTH SYSTEM
              </div>
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/51641852f20ced6f518211c7293b22bb9a9b24e39937ccccd134e24b29cfc7bb?apiKey=e485b3dc4b924975b4554885e21242bb&"
                className="object-contain shrink-0 bg-blend-normal aspect-[1.35] w-[50px]"
              />
            </div>
            <div className="flex overflow-hidden flex-col items-center px-20 mt-16 w-full bg-blend-normal max-md:px-5 max-md:mt-10">
              <div className="flex flex-col justify-center items-center max-w-full w-[900px]">
                <div className="flex flex-col justify-center self-stretch w-full max-md:max-w-full">
                  <div className="flex flex-col justify-center self-center w-full text-center text-black">
                    <div className="text-4xl font-extrabold leading-none max-md:max-w-full">
                      Grow Your Credit Limit Through Step Borrowing
                    </div>
                    <div className="mt-3 text-2xl leading-8 max-md:max-w-full">
                      At <span className="font-black">Moodeng</span>, we reward
                      responsible borrowing by increasing your credit limit with
                      successful repayments.
                    </div>
                  </div>
                  <div className="flex flex-col p-5 mt-8 w-full bg-white rounded-xl border border-indigo-700 border-solid max-md:max-w-full">
                    <div className="pr-16 pb-px pl-16 text-2xl font-extrabold text-center text-indigo-700 max-md:px-5 max-md:max-w-full">
                      Your Credit Limit Grows with Every $20 You Borrow and
                      Repay!
                    </div>
                    <div className="px-20 pb-px mt-4 text-base text-center text-indigo-700 max-md:px-5 max-md:max-w-full">
                      The more you borrow and repay, the more you can borrow in
                      the future.
                    </div>
                    <div className="flex relative justify-between items-start mt-10 max-md:max-w-full">
                      <div className="flex absolute inset-x-0 top-3 z-0 shrink-0 h-0.5 bg-white min-w-[240px] w-[860px] max-md:max-w-full">
                        <svg width="869" height="19" viewBox="0 0 869 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="9" width="860" height="2" fill="#3F51B5" />
                          <path d="M859.5 0L868.833 9.33333L859.5 18.6667" fill="#3F51B5" />
                        </svg>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center text-center text-indigo-700 whitespace-nowrap basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-white min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            1
                          </div>
                        </div>
                        <div className="pb-px text-xl">$15</div>
                        <div className="text-sm">Start</div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center text-center text-indigo-700 basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            2
                          </div>
                        </div>
                        <div className="pb-px text-xl whitespace-nowrap">
                          $20
                        </div>
                        <div className="text-sm">Connect</div>
                        <div className="flex flex-col pt-1.5 text-sm">
                          <div>Borrow + Repay Original $20 to unlock $40</div>
                        </div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center px-1 basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-center text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            3
                          </div>
                        </div>
                        <div className="pb-px text-xl text-center text-indigo-700 whitespace-nowrap">
                          $40
                        </div>
                        <div className="text-sm text-center text-indigo-700">
                          Grow
                        </div>
                        <div className="flex flex-col items-start pt-1.5">
                          <div className="flex min-h-[17px]" />
                        </div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center px-0.5 basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-center text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            4
                          </div>
                        </div>
                        <div className="pb-px text-xl text-center text-indigo-700 whitespace-nowrap">
                          $60
                        </div>
                        <div className="text-sm text-center text-indigo-700">
                          Build
                        </div>
                        <div className="flex flex-col pt-1.5">
                          <div className="flex min-h-[17px]" />
                        </div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center px-1 basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-center text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            5
                          </div>
                        </div>
                        <div className="pb-px text-xl text-center text-indigo-700 whitespace-nowrap">
                          $80
                        </div>
                        <div className="text-sm text-center text-indigo-700">
                          Expand
                        </div>
                        <div className="flex flex-col items-start pt-1.5">
                          <div className="flex min-h-[17px]" />
                        </div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-center text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            6
                          </div>
                        </div>
                        <div className="pb-px text-xl text-center text-indigo-700 whitespace-nowrap">
                          $100
                        </div>
                        <div className="text-sm text-center text-indigo-700">
                          Unlock
                        </div>
                        <div className="flex flex-col items-start pt-1.5">
                          <div className="flex min-h-[17px]" />
                        </div>
                      </div>
                      <div className="flex z-0 flex-col flex-1 shrink items-center text-center text-indigo-700 basis-0">
                        <div className="flex flex-col pb-2.5 w-10 text-base text-white whitespace-nowrap min-h-[50px]">
                          <div className="self-stretch px-4 pt-2 w-full h-10 bg-indigo-700 rounded-3xl min-h-[40px]">
                            7
                          </div>
                        </div>
                        <div className="pb-px text-xl whitespace-nowrap">
                          $120+
                        </div>
                        <div className="text-sm">Ongoing Growth</div>
                        <div className="flex flex-col pt-1.5 text-sm">
                          <div className="px-4">
                            Keep going forever and grow!
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-center mt-8 w-full max-w-[902px] max-md:max-w-full">
                  <div className="flex flex-wrap gap-10 justify-center items-start w-full max-md:max-w-full">
                    <div className="flex flex-col grow shrink min-w-[240px] w-[370px] max-md:max-w-full">
                      <div className="text-3xl leading-none text-neutral-900">
                        Build Your Credit, Step by Step
                      </div>
                      <div className="mt-3.5 text-xs tracking-normal leading-loose text-black text-opacity-80 max-md:max-w-full">
                        Unlock Your Financial Potential with Moodeng's Unique
                        Borrowing System
                      </div>
                    </div>
                    <div className="flex gap-3.5 justify-center items-center text-2xl leading-none text-center whitespace-nowrap min-w-[240px]">
                      <div className="overflow-hidden self-stretch px-14 py-6 my-auto bg-indigo-500 rounded-[114px] text-neutral-100 w-[194px] max-md:px-5">
                        <Link to="/dashboard#request">Borrow</Link>
                      </div>
                      <div className="overflow-hidden self-stretch px-16 py-6 my-auto bg-emerald-400 rounded-[114px] text-zinc-900 w-[182px] max-md:px-5">
                        <Link to="/dashboard#request">Lend</Link>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-5 justify-center items-center mt-6 w-full max-md:max-w-full">
                    <div className="flex overflow-hidden flex-col grow shrink items-start self-stretch px-5 py-7 my-auto bg-white rounded-2xl min-w-[240px] w-[230px] max-md:px-5">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=100 100w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=200 200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=400 400w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=800 800w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b725d82d60bc3b6ec342f9ece31e0aeba8ce29f39d86430b0a7ded9aae48884b?apiKey=e485b3dc4b924975b4554885e21242bb&"
                        className="object-contain aspect-[0.99] rounded-[3951px] w-[66px]"
                      />
                      <div className="mt-3 text-base leading-6 text-neutral-900">
                        If I borrow $35 instead of $40 can I unlock $60?{" "}
                      </div>
                      <div className="self-stretch mt-4 text-sm leading-5 text-zinc-500">
                        Borrowing under $40 won't unlock $60 - it shows you are
                        not ready. But, you can borrow smaller amounts to prove
                        yourself.
                      </div>
                    </div>
                    <div className="flex overflow-hidden flex-col grow shrink self-stretch px-5 py-7 my-auto bg-white rounded-2xl min-w-[240px] w-[230px] max-md:px-5">
                      <div className="flex flex-col justify-center items-center px-3.5 bg-fuchsia-300 rounded-full h-[67px] w-[67px]">
                        <img
                          loading="lazy"
                          srcSet="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=100 100w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=200 200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=400 400w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=800 800w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/80d4256ca7d208d1577d4349fc643c094b08f40fd36b27afa832e2c8cc55505e?apiKey=e485b3dc4b924975b4554885e21242bb&"
                          className="object-contain w-full aspect-[0.79]"
                        />
                      </div>
                      <div className="mt-3 text-base leading-6 text-neutral-900">
                        Does borrowing or repaying more unlock the next level??
                      </div>
                      <div className="mt-4 text-sm leading-5 text-zinc-500">
                        The only thing relevant to unlocking the next level is
                        the amount you borrowed. Not the amount you repaid.
                      </div>
                    </div>
                    <div className="flex overflow-hidden flex-col grow shrink items-start self-stretch px-5 pt-7 pb-12 my-auto bg-white rounded-2xl min-w-[240px] w-[230px] max-md:px-5">
                      <div className="flex flex-col justify-center items-center px-2.5 bg-emerald-400 rounded-full h-[67px] w-[67px]">
                        <img
                          loading="lazy"
                          srcSet="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=100 100w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=200 200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=400 400w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=800 800w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/88425fd4c9dfda3ebc14876b9d41413a45340d35ac6dc6ad7ce5449f1056c6a5?apiKey=e485b3dc4b924975b4554885e21242bb&"
                          className="object-contain w-full aspect-[0.89]"
                        />
                      </div>
                      <div className="mt-3 text-base leading-6 text-neutral-900 w-[245px]">
                        Can I skip a level by borrowing more than required?
                      </div>
                      <div className="self-stretch mt-4 text-sm leading-5 text-zinc-500">
                        No, each level must be unlocked step-by-step with
                        consistent borrowing.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-8 max-w-full rounded-3xl w-[805px]">
                  <div className="flex gap-5 max-md:flex-col">
                    <div className="flex flex-col w-[74%] max-md:ml-0 max-md:w-full">
                      <div className="mt-9 text-2xl leading-8 text-black max-md:mt-10 max-md:max-w-full">
                        <span className="font-extrabold">
                          Why Our Cumulative System Benefits You
                        </span>
                        <br />
                        <br />
                        <ul className="list-disc ml-[5%]">
                          <li>Flexibility to take multiple smaller loans</li>
                          <li>Build credit at your own pace</li>
                          <li>Reward for consistent borrowing and repayment</li>
                          <li>Clear path to accessing larger loan amounts</li>
                        </ul>
                      </div>
                    </div>
                    <div className="flex flex-col ml-5 w-[26%] max-md:ml-0 max-md:w-full">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=100 100w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=200 200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=400 400w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=800 800w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/73519d7687e7177605b4f32f0fab51d5e296870c8bddcbe9deb1d6bba48e23aa?apiKey=e485b3dc4b924975b4554885e21242bb&"
                        className="object-contain grow shrink-0 max-w-full rounded-3xl aspect-[0.94] w-[200px] max-md:mt-10"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id='rules' className="flex flex-col justify-center px-20 py-28 mt-20 max-w-full w-[1440px] max-md:px-5 max-md:py-24 max-md:mt-10">
            <div className="flex flex-col items-start -mb-5 max-md:mb-2.5 max-md:max-w-full">
              <div className="text-3xl leading-none text-neutral-100">
                RULES OF REPAYING
              </div>
              <div className="mt-16 text-2xl leading-none text-neutral-100 max-md:mt-10 max-md:max-w-full">
                Moodeng offers flexible, blockchain-based microloans.
                Repay responsibly to build your credit score.
              </div>
              <div className="self-stretch mt-16 max-md:mt-10 max-md:max-w-full">
                <div className="flex max-md:flex-col">
                  <div className="flex flex-col w-[20%] h-[250px] max-md:ml-0 max-md:w-full">
                    <div className="flex overflow-hidden flex-col grow pt-11 pr-1 pb-24 pl-4 w-full h-full bg-indigo-500 rounded-[30px] max-md:px-5 max-md:mt-3.5">
                      <div className="text-xl leading-8 uppercase mb-5 text-zinc-900 text-opacity-50 w-[90%] max-md:ml-2">
                        DIRECT
                      </div>
                      <div className="w-[150px] text-[22px] leading-7 text-neutral-100 w-[90%] max-md:mt-10">
                        You must pay the lender directly by hitting the repay button.
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[20%] h-[250px] max-md:ml-0 max-md:w-full">
                    <div className="flex overflow-hidden flex-col grow pt-11 pr-1 pb-24 pl-4 w-full h-full bg-emerald-400 rounded-[30px] max-md:px-5 max-md:mt-3.5">
                      <div className="text-xl uppercase mb-5 text-zinc-900 text-opacity-50 w-[90%]">
                        UP-TO-YOU
                      </div>
                      <div className="w-[150px] text-[22px] text-neutral-100 w-[90%] max-md:mt-10">
                        Flexible repayments: Any amount up to deadline
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[20%] h-[250px] max-md:ml-0 max-md:w-full">
                    <div className="flex overflow-hidden flex-col grow pt-11 pr-1 pb-24 pl-4 w-full h-full bg-blue-400 rounded-[30px] max-md:px-5 max-md:mt-3.5">
                      <div className="text-xl uppercase mb-5 text-zinc-900 text-opacity-50 w-[90%]">
                        RESPONSIBLE
                      </div>
                      <div className="w-[150px] text-[22px] text-neutral-100 w-[90%] max-md:mt-10">
                        Build credit score with each on-time payment
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[20%] h-[250px] max-md:ml-0 max-md:w-full">
                    <div className="flex overflow-hidden flex-col grow pt-11 pr-1 pb-24 pl-4 w-full h-full bg-fuchsia-300 rounded-[30px] max-md:px-5 max-md:mt-3.5">
                      <div className="text-xl uppercase mb-5 text-zinc-900 text-opacity-50 w-[90%]">
                        INTEGRITY
                      </div>
                      <div className="w-[150px] text-[22px] text-neutral-100 w-[90%] max-md:mt-10">
                        Blockchain records all loan transactions
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[20%] h-[250px] max-md:ml-0 max-md:w-full">
                    <div className="flex overflow-hidden flex-col grow pt-11 pr-1 pb-24 pl-4 w-full h-full bg-amber-500 rounded-[30px] max-md:px-5 max-md:mt-3.5">
                      <div className="text-xl leading-7 mb-5 uppercase text-zinc-900 text-opacity-50 w-[90%]">
                        TIMELY
                      </div>
                      <div className="w-[150px] text-[22px] leading-7 text-neutral-100 w-[90%] max-md:mt-10">
                        Sign up for notifications about your loans{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col px-20 pt-6 pb-24 mt-20 max-w-full w-[1264px] max-md:px-5 max-md:mt-10">
            <div className="flex flex-col max-md:max-w-full">
              <div className="self-center text-4xl text-center text-white max-md:max-w-full">
                How Direct Lend & Borrow Works
              </div>
              <div className="mt-28 max-md:mt-10 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col">
                  <div className="flex flex-col w-[22%] max-md:ml-0 max-md:w-full">
                    <div className="flex relative flex-col px-11 py-24 mt-7 text-3xl text-center text-white whitespace-nowrap aspect-square max-md:px-5 max-md:mt-10">
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/9cb588d4fc7188a686c4abc0cbcc8130312b79f2fc02bc61cd27599696614c3f?apiKey=e485b3dc4b924975b4554885e21242bb&"
                        className="object-contain absolute inset-0 size-full"
                      />
                      <p className="sticky">Borrower</p>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[56%] max-md:ml-0 max-md:w-full">
                    <div className="flex flex-col items-center w-full text-2xl text-center text-white max-md:mt-2.5 max-md:max-w-full">
                      <div>Funds in USDT/USDC</div>
                      <svg className="self-stretch mt-3.5 w-full aspect-[8.4] max-md:max-w-full" width="574" height="73" viewBox="0 0 574 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.6001 66.4C193.2 -17.8667 382.8 -17.8667 572.4 66.4" stroke="#4169E1" stroke-width="4.74" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.70036 69.8047L25.5954 72.5589L27.8971 67.2744L7.86342 64.8644L15.921 46.3649L10.1982 45.6764L0.989826 66.8182C0.684731 67.519 0.693536 68.2273 1.01431 68.7873C1.33508 69.3474 1.94155 69.7133 2.70036 69.8047Z" fill="#4169E1" />
                      </svg>
                      <svg className="self-stretch mt-14 w-full aspect-[8.4] max-md:mt-10 max-md:max-w-full" width="573" height="73" viewBox="0 0 573 73" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M570.4 6.60001C380.8 90.8667 191.2 90.8667 1.6001 6.60001" stroke="#4169E1" stroke-width="4.74" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M570.46 4.787L547.891 0.0534644L545.138 5.11795L564.887 9.25989L555.252 26.9892L560.893 28.1723L571.904 7.91083C572.269 7.23924 572.322 6.53288 572.051 5.94707C571.78 5.36127 571.208 4.94399 570.46 4.787Z" fill="#4169E1" />
                      </svg>
                      <div className="mt-2">Repayment + Interest</div>
                      <div className="flex overflow-hidden gap-2.5 justify-center items-center px-7 py-2.5 mt-3.5 bg-amber-500 rounded-[555px] max-md:px-5">
                        <div className="self-stretch my-auto">
                          Credit Score Improves
                        </div>
                        <img
                          loading="lazy"
                          src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/74468dc87694573da910810782b85ae001cabf498799ed50cd246f13a7556916?apiKey=e485b3dc4b924975b4554885e21242bb&"
                          className="object-contain shrink-0 self-stretch my-auto aspect-[0.56] w-[27px]"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col ml-5 w-[22%] max-md:ml-0 max-md:w-full">
                    <div className="flex relative flex-col px-16 py-24 mt-7 text-3xl text-center text-white whitespace-nowrap aspect-square max-md:px-5 max-md:mt-10">
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/9eca2ffd3b5bc37a22e620f26b1e785938b01c7cf0219c0a27edbc3f71a8a5ff?apiKey=e485b3dc4b924975b4554885e21242bb&"
                        className="object-contain absolute inset-0 size-full"
                      />
                      <p className="sticky">Lender</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <MoodengCreditSection />
        </div>
      </div>
      <style jsx>{"builder-component { max-width: none !important; }"}</style>
    </>
  );
}
